import React, { useEffect, useState } from 'react';
import {
    Dialog,
    Button,
    Box
} from '@mui/material';
import { MdClose } from 'react-icons/md';

const AddTicketDialog = ({ open, onClose, handleAddTicket, loading }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');

    useEffect(() => {
        if (open) {
            setTitle('');
            setDescription('');
            // Set default date to today
            const today = new Date().toISOString().split('T')[0];
            setDate(today);
        }
    }, [open])


    const handleSubmit = (e) => {
        e.preventDefault();
        handleAddTicket({ title, description, date });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <form onSubmit={handleSubmit}>
                <div className="card mb-0">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className="card-title mb-0">Add Ticket</h6>
                        <button type="button" className="btn btn-sm btn-light p-1" onClick={onClose}>
                            <MdClose size={18} />
                        </button>
                    </div>

                    <div className="card-body">
                        <div className="row gy-3">
                            <div className="col-md-12">
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    rows={4}
                                    placeholder="Enter Description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="col-12 text-end">
                                <button type="button" className="btn btn-secondary me-2" onClick={onClose}>
                                    Cancel
                                </button>
                                <button disabled={loading} type="submit" className="btn btn-primary">
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm" />
                                    ) : (
                                        "Save"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Dialog>
    );
};

export default AddTicketDialog;
